import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  BidsQuery,
  CreateBidMutation,
  CreateBidMutationVariables,
  OpportunityQuery,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const createBid = graphql(`
  mutation createBid($bid: CreateBidRequest!) {
    createBid(bid: $bid) {
      id
      createdAt
      updatedAt
      procurementStageId
      opportunity {
        id
        name
      }
    }
  }
`);
export function useCreateBid(
  options?: UseMutationOptions<CreateBidMutation, unknown, CreateBidMutationVariables, unknown>,
) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(createBid, {
    ...options,
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);
      if (data.createBid.opportunity) {
        queryClient.setQueryData(
          ["opportunity", data.createBid.opportunity.id],
          (prevData: OpportunityQuery | undefined) => {
            if (!prevData) return prevData;
            return {
              opportunity: {
                ...prevData.opportunity,
                bid: {
                  id: data.createBid.id,
                },
              },
            };
          },
        );
      }

      queryClient.setQueryData(["bids"], (prevData: BidsQuery | undefined) => {
        if (!prevData) return prevData;

        const updatedResults = [data.createBid, ...prevData.bids.results];
        return {
          bids: {
            results: updatedResults,
            totalResults: prevData.bids.totalResults + 1,
          },
        };
      });
    },
  });
  return { data: data?.createBid, ...rest };
}
